import { RoutingHelper } from './../../../services/helpers/routing.helper';
import { AfterViewInit, Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { DashboardHelper } from './../../../services/dashboard.service';
import { EventManagerHelper } from './../../../services/event-managers/event.manager.helper';
import { BlueprintDataHelper } from './../../../services/helpers/blueprint-data.helper';
import { NodeHelper } from './../../../services/helpers/node.helper';
import { BlueprintStore } from './../../../services/stores/blueprint.store';
import { WorkspaceStore } from './../../../services/stores/workspace.store';
import { IBluePrintNodeModel } from './../../../models/blueprint/blueprint-node.model';
import { CATCH_INTERNAL_APP_REPORT_LOWER, CATCH_INTERNAL_APP_WIKI_LOWER } from '../../../modules/catch-core/data/constants/app.constants';
import * as DefaultValueConstants from '../../../modules/catch-core/data/constants/default-value.constants';

/**
 * CreateNodeComponent
 *
 * This component provides the UI for creating new nodes.
 * The actual node creation and edit panel opening logic is delegated to NodeHelper,
 * following the Single Responsibility Principle.
 */
@Component({
  selector: 'app-create-node',
  templateUrl: './create-node.component.html',
  styleUrls: ['./create-node.component.css'],
  standalone: false,
})
export class CreateNodeComponent extends BaseComponent implements AfterViewInit {
  public mouseoverCreate = false;
  public nodeTypes: IBluePrintNodeModel[] = [];

  constructor(
    private nodeHelper: NodeHelper,
    private eventManageHelper: EventManagerHelper,
    public dashboardHelper: DashboardHelper,
    private blueprintDataHelper: BlueprintDataHelper,
    private blueprintStore: BlueprintStore,
    private workspaceStore: WorkspaceStore,
    private routingHelper: RoutingHelper,
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.subscribers.blueprint = this.blueprintStore.$selectedBluePrint.subscribe((blueprint: any) => {
      if (blueprint) {
        this.nodeTypes = this.blueprintDataHelper.getNodeTypes(blueprint);
      }
    });

    this.subscribers.isSelectedNodeExistingInWorkspace = this.workspaceStore.$isSelectedNodeExistingInWorkspace.subscribe((isExist: boolean | null) => {
      if (isExist !== null) {
        this.syncEditPanelWithSelectedNodePresence(isExist);
      }
    });
  }

  //todo - this logic should move to central place as this logic not belong to this component
  private syncEditPanelWithSelectedNodePresence(isExist: boolean): void {
    const appName = this.dashboardHelper.currentETApplication?.name?.toLocaleLowerCase();
    if (!appName) {
      return;
    }
    if (appName === CATCH_INTERNAL_APP_REPORT_LOWER || appName === CATCH_INTERNAL_APP_WIKI_LOWER) {
      return;
    }

    this.dashboardHelper.isRootNode = false;

    if (!isExist) {
      this.dashboardHelper.setShowRightPanel(false);
      this.workspaceStore.selectedWSINode = null;
      return;
    }

    if (!this.dashboardHelper.getShowRightPanel()) {
      return;
    }

    const routeKey = this.workspaceStore.selectedWSINode?.key || this.workspaceStore.selectedWSINode?.id;
    if (routeKey) {
      this.routingHelper.navigateToSharedEditPanel('workspace-node-property', routeKey);
    }
  }

  public onNodeCreate(nodeTypeName: string): void {
    if (nodeTypeName) {
      this.nodeHelper.createNodeByNodeTypeName(nodeTypeName, DefaultValueConstants.NODE_DEFAULT_NAME, DefaultValueConstants.NODE_SERVER_LOCATION, false);
      this.eventManageHelper.setEditPanelSummaryInHighlight();
    }
  }
}
